<template>
    <div class="row">
        <div class="col-lg-12 col-md-12">

            <div class="card headertop">
                <div class="card-header">
                    <h4 class="title" style="text-align:center;margin:auto; padding-bottom:15px;">Csontract {{ model.product }} in state {{ model.state }}</h4>

                    <hr>
                    <div class="card-body" style="margin:auto;" v-if="role === 'agent' || role === 'supplier'">
                        <h5 class="info-text">Company</h5>

                        <div class="row justify-content-center">

                            <div class="col-md-12 col-sm-12">
                                <fg-input name="vat"
                                          placeholder="VAT (required)"
                                          v-model="model.vat"
                                          v-validate="modelValidations.vat"
                                          :error="getError('vat')"
                                          addon-left-icon="nc-icon nc-single-02" disabled>
                                </fg-input>

                            </div>



                            <div class="col-md-12 col-sm-12">
                                <fg-input name="company_name"
                                          placeholder="Company name (required)"
                                          v-model="model.company_name"
                                          v-validate="modelValidations.company"
                                          :error="getError('company_name')"
                                          addon-left-icon="nc-icon nc-circle-10">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="legal form"
                                          placeholder="legal form (required)"
                                          v-model="model.legal_form"
                                          v-validate="modelValidations.legal_form"
                                          :error="getError('legal_form')"
                                          addon-left-icon="nc-icon nc-circle-10">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input>
                                    <el-select class="select-primary"
                                               size="large"
                                               placeholder="Language"
                                               v-model="model.language">
                                        <el-option v-for="option in languages"
                                                   class="select-primary"
                                                   :value="option"
                                                   :label="option"
                                                   :key="option">
                                        </el-option>
                                    </el-select>
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="email"
                                          placeholder="Email (required)"
                                          v-model="model.contact.email"
                                          v-validate="modelValidations.email"
                                          :error="getError('email')"
                                          addon-left-icon="nc-icon nc-send">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="phone"
                                          placeholder="Phone (required)"
                                          v-model="model.contact.phone_number"
                                          v-validate="modelValidations.phone"
                                          :error="getError('phone')"
                                          addon-left-icon="nc-icon nc-mobile">
                                </fg-input>
                            </div>


                            <div class="col-md-12 col-sm-12">
                                <fg-input name="companystreet"
                                          placeholder="Street name (required)"
                                          v-model="model.companyAddress.street"
                                          v-validate="modelValidations.company_street"
                                          :error="getError('companystreet')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="companystreetnumber"
                                          placeholder="Street number (required)"
                                          v-model="model.companyAddress.street_number"
                                          v-validate="modelValidations.street_number"
                                          :error="getError('companystreetnumber')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="companyboxnumber"
                                          placeholder="Box number"
                                          v-model="model.companyAddress.box_number"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-6">
                                <fg-input name="companypostal_code"
                                          placeholder="Post code (required)"
                                          v-model="model.companyAddress.postal_code"
                                          v-validate="modelValidations.company_post_code"
                                          :error="getError('companypostal_code')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12  col-sm-6">
                                <fg-input name="companylocality"
                                          placeholder="Locality (required)"
                                          v-model="model.companyAddress.locality"
                                          v-validate="modelValidations.company_locality"
                                          :error="getError('companylocality')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>


                        </div>

                        <br><br>
                        <h5 class="info-text">Point of sale</h5>

                        <div class="row justify-content-center">
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="Point of sale name"
                                          placeholder="Point of sale name (required)"
                                          v-model="model.installationAddress.name"
                                          addon-left-icon="nc-icon nc-circle-10">
                                </fg-input>
                            </div>

                            <div class="col-md-12 col-sm-12">
                                <fg-input>
                                    <el-select class="select-primary"
                                               size="large"
                                               placeholder="Gender"
                                               v-model="model.contact.gender">
                                        <el-option v-for="option in gender"
                                                   class="select-primary"
                                                   :value="option"
                                                   :label="option"
                                                   :key="option">
                                        </el-option>
                                    </el-select>
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="First name"
                                          placeholder="First name (required)"
                                          v-model="model.contact.first_name"
                                          v-validate="modelValidations.firstName"
                                          :error="getError('First name')"
                                          addon-left-icon="nc-icon nc-circle-10">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="last name"
                                          placeholder="Last name (required)"
                                          v-model="model.contact.last_name"
                                          v-validate="modelValidations.lastName"
                                          :error="getError('last name')"
                                          addon-left-icon="nc-icon nc-circle-10">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="function"
                                          placeholder="Function (required)"
                                          v-model="model.contact.title"
                                          v-validate="modelValidations.title"
                                          :error="getError('function')"
                                          addon-left-icon="nc-icon nc-circle-10">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="activity"
                                          placeholder="Activity (required)"
                                          v-model="model.activity"
                                          v-validate="modelValidations.activity"
                                          :error="getError('activity')"
                                          addon-left-icon="nc-icon nc-circle-10">
                                </fg-input>
                            </div>

                            <div class="col-md-12 col-sm-12">
                                <fg-input name="installationstreet"
                                          placeholder="Street name (required)"
                                          v-model="model.installationAddress.street"
                                          v-validate="modelValidations.installation_street"
                                          :error="getError('installationstreet')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="installationstreetnumber"
                                          placeholder="Street number (required)"
                                          v-model="model.installationAddress.street_number"
                                          v-validate="modelValidations.installation_street_number"
                                          :error="getError('installationstreetnumber')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="installationboxnumber"
                                          placeholder="Box number (required)"
                                          v-model="model.installationAddress.box_number"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-6">
                                <fg-input name="installationpostal_code"
                                          placeholder="Post code (required)"
                                          v-model="model.installationAddress.postal_code"
                                          v-validate="modelValidations.installation_post_code"
                                          :error="getError('installationpostal_code')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>
                            <div class="col-md-12  col-sm-6">
                                <fg-input name="installationlocality"
                                          placeholder="Locality (required)"
                                          v-model="model.installationAddress.locality"
                                          v-validate="modelValidations.installation_locality"
                                          :error="getError('installationlocality')"
                                          addon-left-icon="nc-icon nc-shop">
                                </fg-input>
                            </div>

                            <div class="col-sm-12 col-md-13">
                                <fg-input>
                                    <el-select multiple class="select-primary"

                                               size="large"
                                               v-model="model.calendar"
                                               placeholder="Working day">
                                        <el-option v-for="option in workingDays"

                                                   class="select-primary"
                                                   :value="option"
                                                   :label="option"
                                                   :key="option">
                                        </el-option>
                                    </el-select>
                                </fg-input>
                            </div>
                            <div class="col-md-2 col-sm-12">
                                <div class="form-group">
                                    <el-time-select
                                            v-model="model.from_am"
                                            :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                                            placeholder="From">
                                    </el-time-select>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-12">
                                <div class="form-group">
                                    <el-time-select
                                            v-model="model.to_am"
                                            :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                                            placeholder="To">
                                    </el-time-select>
                                </div>
                            </div>
                            <span style="text-align:center;"><h4 style="margin-top: 05px;">-</h4></span>
                            <div class="col-md-2 col-sm-12">
                                <div class="form-group">
                                    <el-time-select
                                            v-model="model.from_pm"
                                            :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                                            placeholder="From">
                                    </el-time-select>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-12">
                                <div class="form-group">
                                    <el-time-select
                                            v-model="model.to_pm"
                                            :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                                            placeholder="To">
                                    </el-time-select>
                                </div>
                            </div>



                        </div>

                        <br><br>
                        <h5 class="info-text">Payment</h5>

                        <div class="row justify-content-center">

                            <div class="col-md-12 col-sm-12">
                                <fg-input name="beneficiary"
                                          placeholder="Beneficiary (required)"
                                          v-model="model.payment.beneficiary"
                                          v-validate="modelValidations.beneficiary"
                                          :error="getError('beneficiary')"
                                          addon-left-icon="nc-icon nc-bank">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="iban"
                                          placeholder="IBAN (required)"
                                          v-model="model.payment.iban"
                                          v-validate="modelValidations.iban"
                                          :error="getError('iban')"
                                          addon-left-icon="nc-icon nc-bank">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="bic"
                                          placeholder="BIC"
                                          v-model="model.payment.bic"
                                          addon-left-icon="nc-icon nc-bank">
                                </fg-input>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <fg-input name="bank"
                                          placeholder="Bank"
                                          v-model="model.payment.bank"
                                          addon-left-icon="nc-icon nc-bank">
                                </fg-input>
                            </div>
                        </div>

                        <h5 class="info-text">Terminals</h5>
                        <div class="row justify-content-center">
                            <div class="col-md-3" style="">
                                <fg-input>
                                    <el-select class="select-primary"
                                               size="large"
                                               placeholder="Terminal supplier"
                                               v-model="model.terminal.supplier"
                                               @change="terminalType()">
                                        <el-option v-for="option in terminals"
                                                   class="select-primary"
                                                   :value="option._id"
                                                   :label="option._id"
                                                   :key="option._id">
                                        </el-option>
                                    </el-select>
                                </fg-input>
                            </div>
                            <div class="col-md-3" style="">
                                <fg-input>
                                    <el-select class="select-primary"
                                               size="large"
                                               placeholder="Terminal type"
                                               v-model="model.terminal.type"
                                    >
                                        <el-option v-for="option in terminals_type"
                                                   class="select-primary"
                                                   :value="option.type"
                                                   :label="option.type"
                                                   :key="option.type">
                                        </el-option>
                                    </el-select>
                                </fg-input>
                            </div>
                            <div class="col-md-4" style="">
                                <fg-input name="tid"
                                          placeholder="TID"
                                          v-model="model.terminal.tid"
                                >
                                </fg-input>
                            </div>
                            <div class="col-md-2">
                                <button class="btn btn-success btn-fill" v-on:click="addTerminal" style="margin: auto;">
                                    Add
                                </button>

                            </div>

                            <div class="col-md-12">
                                <el-tag
                                        :key="tag"
                                        v-for="tag in model.terminals"
                                        type="primary"
                                        :closable="true"
                                        :close-transition="false"
                                        @close="handleClose(tag)"
                                >
                                    supplier : {{tag.supplier}} -
                                    type : {{tag.type}} -
                                    tid : {{ tag.tid }}
                                </el-tag>

                            </div>

                        </div>



                        <div class="row justify-content-center" style="margin-top:50px">

                            <div class="col-12 col-md-12 col-lg-12" v-for="item in activities" v-if="item.name===contract.product">

                                <div v-for="obj, key in contract.datagen.contracts" v-if="item.activities.length > 1 && key===contract.product" >
                                    <h5 class="info-text" style="text-align: center;">{{item.name}} activities  </h5>
                                    <fg-input>
                                        <el-select v-model="contractActivities[item.name]" multiple filterable placeholder="Select"> <!-- obj.activities.name -->
                                            <el-option
                                                    v-for="sub in item.activities"
                                                    :key="sub.name"
                                                    :label="sub.name"
                                                    :value="sub.name">
                                            </el-option>
                                        </el-select>
                                    </fg-input>
                                </div>

                                <div v-for="obj, key in contract.datagen.contracts" v-if="item.activities.length < 2 && key===contract.product" >

                                    <h5 class="info-text" style="text-align: center;">{{item.name}} activities</h5>
                                    <div style="text-align:center;color: gray;">There is no activities to specify for this supplier</div>
                                </div>
                            </div>
                            <br><br>


                                <div class="col-md-12" style="margin:auto;text-align:center;margin-top:50px">

                                    <div class="row justify-content-center">


                                    </div>
                                </div>


                            <div class="col-md-12" style="margin:auto;text-align:center;margin-top:50px">
                                <hr>
                                <div class="row justify-content-center">
                                    <div class="col-md-6">
                                    <button class="btn btn-info btn-fill" style="width:50%" v-on:click="genContract()">
                                        Download preview
                                    </button>
                                    </div>
                                    <div class="col-md-6">
                                    <button class="btn btn-success btn-fill" style="width:50%" v-on:click="genContractValidate()">
                                        Validate changes
                                    </button>
                                    </div>
                                </div>
                            </div>

                        </div>



                        </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import {Table, TableColumn,TimeSelect, Select, Tag, Option} from 'element-ui'

    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)

    export default {

        components: {
            [Option.name]: Option,
            [Select.name]: Select,
            [TimeSelect.name]: TimeSelect,
            [Tag.name]: Tag,
        },
        data () {
            return {
                contractPage: true,
                contract: {},
                links: [],
                contractActivities: {
                    EcoSodexo: [],
                    EcoEdenred: [],
                    GiftEdenred: [],
                    MealEdenred: [],
                    MealMonizze: [],
                    EcoMonizze: [],
                    GiftMonizze: [],
                    MealSodexo: []
                },
                role: localStorage.role,
                terminals: [],
                activities: [],
                type: '',
                supplier:'',
                tid:'',
                update : {
                    status: '',
                    uid: '',
                    note: '',
                    id: '',
                },
                categoryAgents: [{ value: 'refus', label:'Refus'},{ value: 'attente terminal', label:'Attente Terminal'}, { value: 'valide', label:'Valide'}],
                categorySuppliers: [{ value: 'validation fournisseur', label:'Validation Fournisseur'},  { value: 'refus Fournisseur', label:'refus Fournisseur'}], // { value: 'correction fournisseur', label:'Correction Fournisseur'},
                languages: ['fr', 'nl'],
                tags: {
                    inputVisible: false,
                    inputValue: ''
                },
                terminals: [],
                terminals_type: [],
                timeFrom: '',
                timeTo: '',
                timeFrom2: '',
                timeTo2: '',
                gender: ['M', 'F', 'X'],
                workingDays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
                vatInfo : {},
                model: {
                    from_am : '09:00',
                    to_am: '13:00',
                    from_pm: '14:00',
                    to_pm: '18:00',
                    vat: 'BE0548732067',
                    activity: '',
                    company_name: '',
                    legal_form: '',
                    language: 'fr',
                    calendar: [],
                    companyAddress: {
                        street: '',
                        street_number: '',
                        postal_code: '',
                        locality: '',
                    },
                    installationAddress: {
                        street: '',
                        street_number: '',
                        postal_code: '',
                        locality: '',
                    },
                    contact: {
                        email: '',
                        first_name: '',
                        last_name: '',
                        phone_number: '',
                        title: '',
                        gender: ''
                    },
                    payment: {
                        bank: '',
                        iban: '',
                        bic: '',
                        beneficiary: ''
                    },
                    terminals: [],
                    terminal: {
                        supplier: '',
                        type: '',
                        tid: ''
                    }
                },
                modelValidations: {
                    legal_form: {
                        required: true
                    },
                    bank: {
                        required: true,
                    },
                    iban: {
                        required: true,
                    },
                    beneficiary: {
                        required: true,
                    },
                    installation_street: {
                        required: true,
                        min: 2
                    },
                    installation_street_number: {
                        required: true,
                        min: 1
                    },
                    installation_locality: {
                        required: true,
                        min: 2
                    },
                    installation_post_code: {
                        required: true,
                        min: 2
                    },
                    company_street: {
                        required: true,
                        min: 2
                    },
                    company_street_number: {
                        required: true,
                        min: 1
                    },
                    company_locality: {
                        required: true,
                        min: 2
                    },
                    company_post_code: {
                        required: true,
                        min: 2
                    },
                    company: {
                        required: true,
                        min: 2
                    },
                    vat: {
                        required: true,
                        min: 10
                    },
                    firstName: {
                        required: true,
                        min: 2
                    },
                    lastName: {
                        required: true,
                        min: 5
                    },
                    title: {
                        required: true
                    },
                    activity: {
                        required: true
                    },
                    email: {
                        required: true,
                        email: true
                    },
                    phone: {
                        required: true
                    },
                    street_number: {
                        required: true,
                        min: 1
                    }
                }
            }
        },
        mounted() {
            this.getContract(),
                this.getTerminals(),
                this.getActivities()
        },
        methods: {
            setEmptyActivities() {

                this.activities.forEach( el => {
                    console.log(el.name + ' with '+ el.activities.length + ' activities')
                    //console.log(this.contracts)
                    Object.keys(this.contract.datagen.contracts).forEach(key => {
                        if(el.name === this.contracts.contracts[key].offName && el.activities.length < 2 && this.contracts.contracts[key].status === true) {
                            console.log("ToSet")
                            this.contractActivities[el.name] = [el.activities[0]]
                        }

                    })

                })
            },
            getActivities() {
                this.$http({
                    method: 'get',
                    url: this.$apiUrl + '/contract/getActivities',
                    headers: {'Authorization': 'Bearer ' + localStorage.token}
                }).then(response => (
                    //console.log(response.data),
                    this.activities = response.data
                )).catch(err => {
                    this.$notify({
                        message: 'Impossible to retrieve data',
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    })
                })
            },

            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            validate() {
                return this.$validator.validateAll().then(res => {
                    this.$emit('on-validated', res, this.model)
                    return res
                })
            },
            getTerminals() {
                this.$http({
                    method: 'get',
                    url: this.$apiUrl + '/terminal/terminalBySupplier',
                    headers: {'Authorization': 'Bearer ' + localStorage.token}
                }).then(response => (
                    console.log(response.data),
                        this.terminals = response.data
                )).catch(err => {
                    this.$notify({
                        message: 'Impossible to retrieve data',
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    })
                })
            },
            validateVATFromDB() {
                this.$http({
                    method: 'get',
                    url: this.$apiUrl + '/validity/vatFromDB',
                    headers: {'Authorization': 'Bearer ' + localStorage.token},
                    params: {vat : this.model.vat},
                }).then(response => (
                    this.splitVATInfoFromDB(response)
                )).catch(err => {
                    this.$notify({
                        message: 'Impossible to retrieve data',
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    })
                })
            },
            handleClose (tag) {
                this.model.terminals.splice(this.model.terminals.indexOf(tag), 1)
            },
            showInput () {
                this.tags.inputVisible = true
                this.$nextTick(() => {
                    this.$refs.saveTagInput.$refs.input.focus()
                })
            },

            handleInputConfirm () {
                let inputValue = this.tags.inputValue
                if (inputValue) {
                    this.model.terminal.tid.push(inputValue)
                }
                this.tags.inputVisible = false
                this.tags.inputValue = ''
            },
            terminalType() {
                this.model.terminal.type = '';
                this.terminals.forEach(el => {
                    if(el._id === this.model.terminal.supplier) {
                        this.terminals_type = el.types
                    }
                })
            },
            addTerminal() {
                this.model.terminals.push(JSON.parse(JSON.stringify(this.model.terminal)))
                /*
                this.terminals.forEach(sub => {
                  if(sub._id === this.model.type) {
                    this.model.terminals.push({
                      type: sub.type,
                      supplier: sub.supplier,
                      tid: this.model.terminal.tid
                    })
                  }
                })
                */
            },
            removeTerminal(index) {
                this.contract.terminals.splice(index,1)
            },
            updateTerminal() {

            },
            downloadPdf (pdf) {
                this.$http({
                    method: 'get',
                    url: this.$apiUrl + '/contract/pdf',
                    headers: {'Authorization': 'Bearer ' + localStorage.token},
                    responseType: 'blob',
                    params: {pdf: pdf}
                }).then(response => (
                    this.link = document.createElement('a'),
                        this.url = window.URL.createObjectURL(new Blob([response.data])),
                        this.link.href = this.url, this.link.setAttribute('download', pdf), document.body.appendChild(this.link), this.link.click()
                )).catch(err => {
                    alert(err)
                })
            },
            getContract() {
                this.$http({
                    method: 'get',
                    url: this.$apiUrl + '/contract/contracts',
                    headers: {'Authorization': 'Bearer ' + localStorage.token},
                    params: {by: 'id',id: this.$route.query.id.toString()},
                }).then(response => (
                    this.contract = response.data,
                        this.update.status = response.data.state,
                        this.update.uid = response.data.uid,
                        this.update.id = response.data._id,
                        this.model.uid = response.data.uid,
                        this.model = response.data.datagen,
                        this.model.state = response.data.state,
                        this.model.product = response.data.product,
                        this.model.history = response.data.history,
                        this.model.user = response.data.user,
                        this.model.sign_date = response.data.sign_date,
                        this.contractActivities = response.data.datagen.contracts,
                        Object.keys(this.model.contracts).forEach(el => {if(el != this.model.product) { delete this.model.contracts[el] }})
                        //this.model.activities = response.data.contracts[this.model.product]
                )).catch(err => {
                    this.$notify({
                        message: 'Impossible to retrieve data',
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    })
                })
            },
            updateContract() {
                this.$http({
                    method: 'put',
                    url: this.$apiUrl + '/contract/contract',
                    headers: {'Authorization': 'Bearer ' + localStorage.token},
                    params: this.update,
                }).then(response => (
                    this.$notify({
                        message: 'contract updated',
                        type: 'success',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    }),
                        this.getContract()
                )).catch(err => {
                    this.$notify({
                        message: 'Impossible to update this contract',
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    })
                })


            },
            async genContract() {
                this.model.temporary = true,
                this.model.update_from = this.contract._id,
                    this.model.uid = this.contract.uid,
                    //this.setEmptyActivities(),
                    console.log(JSON.stringify(this.model))
                    await this.$http({
                        method: 'post',
                        url: this.$apiUrl + '/contract/contract',
                        headers: {'Authorization': 'Bearer ' + localStorage.token},
                        data: this.model
                    }).then(response => (
                        this.links = response.data,
                            this.downloadPdf(this.links[0].pdf),
                            console.log(response.data)
                    )).catch(err => {
                        this.$notify({
                            message: 'Impossible to generate this contract',
                            type: 'danger',
                            horizontalAlign: 'center',
                            verticalAlign: 'top'
                        })
                    })


            },
            async genContractValidate() {
                this.model.temporary = false,
                    this.model.update_from = this.contract._id,
                    this.model.uid = this.contract.uid,
                    //this.setEmptyActivities(),
                    console.log(JSON.stringify(this.model))
                await this.$http({
                    method: 'post',
                    url: this.$apiUrl + '/contract/contract',
                    headers: {'Authorization': 'Bearer ' + localStorage.token},
                    data: this.model
                }).then(response => (
                    this.$router.push({ path: `/spe/contract/edit?id=` + response.data[0]._id}),
                        console.log(response),
                        this.contract = {},
                        //alert(this.$route.query.id.toString()),
                        this.getContract(),
                        this.$notify({
                            message: 'Contract updated',
                            type: 'success',
                            horizontalAlign: 'center',
                            verticalAlign: 'top'
                        })


                )).catch(err => {
                    this.$notify({
                        message: 'Impossible to generate this contract',
                        type: 'danger',
                        horizontalAlign: 'center',
                        verticalAlign: 'top'
                    })
                })


            },
        }
    }

</script>

<style scoped>

</style>
